import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import InwardPage from "@/pages/InwardPage";
import SegregationPage from "@/pages/SegregationPage";
import DispatchPage from "@/pages/DispatchPage";
import StaffPage from "@/pages/StaffPage";
import ReportsPage from "@/pages/ReportsPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import ChallanPage from "@/pages/ChallanPage";
import UserApprovalsPage from "@/pages/UserApprovalsPage";
import RequestsPage from "@/pages/RequestsPage";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogin = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setToken(token);
    setUser(user);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!token ? <LoginPage onLogin={handleLogin} /> : <Navigate to="/" />} />
          <Route path="/signup" element={!token ? <SignupPage /> : <Navigate to="/" />} />
          <Route path="/forgot-password" element={!token ? <ForgotPasswordPage /> : <Navigate to="/" />} />
          
          <Route element={token ? <Layout user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}>
            <Route path="/" element={<DashboardPage user={user} token={token} />} />
            <Route path="/inward" element={<InwardPage user={user} token={token} />} />
            <Route path="/segregation" element={<SegregationPage user={user} token={token} />} />
            <Route path="/dispatch" element={<DispatchPage user={user} token={token} />} />
            <Route path="/challan" element={<ChallanPage user={user} token={token} />} />
            <Route path="/staff" element={<StaffPage user={user} token={token} />} />
            <Route path="/reports" element={<ReportsPage user={user} token={token} />} />
            <Route path="/admin" element={<AdminSettingsPage user={user} token={token} />} />
            <Route path="/approvals" element={<UserApprovalsPage user={user} token={token} />} />
            <Route path="/requests" element={<RequestsPage user={user} token={token} />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;